<template>
  <div class="fe-flex fe-flex-col fe-gap-xxs">
    <div
      v-for="progressBar in maxProgressBarArray"
      :key="progressBar"
      class="fe-flex fe-items-center fe-justify-between fe-gap-xxs lg:fe-gap-xs"
    >
      <div class="fe-text-body-xxs fe-text-primary-grey-60">
        {{ progressBar }}
      </div>
      <div>
        <StarRating
          :readOnly="true"
          :initialRating="0"
          size="s"
          :maxStars="1"
        />
      </div>
      <div class="fe-flex-grow">
        <ProgressBar
          :progress="getRatingStats(progressBar)"
          backgroundColor="fe-bg-primary-grey-40"
          filledColor="fe-bg-success-50"
        />
      </div>
      <div class="fe-w-l fe-text-body-xxs fe-text-primary-grey-80 sm:fe-pl-xxs">
        <div>{{ getRatingStats(progressBar) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProgressBar from "@/components/DesignSystem/ProgressBar/ProgressBar.vue"
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"

  export default {
    name: "RatingHistogram",
    components: { ProgressBar, StarRating },
    inject: ["globalState"],
    props: {
      maxProgressBars: {
        type: [String, Number],
        default: 5,
        required: true,
      },
    },
    computed: {
      maxProgressBarArray() {
        // Dynamically generate an array in reverse order from 'length' to '1'
        return Array.from(
          { length: this.maxProgressBars },
          (_, i) => this.maxProgressBars - i,
        )
      },
      totalRatings() {
        return this.globalState.ratingsCount
      },
      ratingsCountDetails() {
        return this.globalState.ratingsCountDetails
      },
    },
    methods: {
      getRatingStats(progressBarRating) {
        const rating = this.ratingsCountDetails?.[progressBarRating] || 0

        // If totalRatings is 0 or the rating is 0, return 0 (failsafe for empty data)
        if (this.totalRatings === 0 || rating <= 0) {
          return 0
        }

        return rating
      },
    },
  }
</script>
